import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { mensajeDeError } from '../api/client';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { Campo, Etiqueta, Entrada, MensajeError } from '../components/ui/Form';
import { Envoltura, TituloForm, TextoForm, PieForm } from './Login';

function Registro() {
  const { registro } = useAuth();
  const navigate = useNavigate();

  const [datos, setDatos] = useState({ nombre: '', email: '', telefono: '', password: '' });
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  const cambiar = (campo) => (e) => setDatos((d) => ({ ...d, [campo]: e.target.value }));

  const enviar = async (e) => {
    e.preventDefault();
    setError('');
    setEnviando(true);
    try {
      await registro(datos);
      navigate('/mi-cuenta/paquete', { replace: true });
    } catch (err) {
      setError(mensajeDeError(err));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Envoltura>
      <Card>
        <TituloForm>Crea tu cuenta</TituloForm>
        <TextoForm>Regístrate para reservar tu lugar en el estudio.</TextoForm>
        {error && <MensajeError role="alert">{error}</MensajeError>}
        <form onSubmit={enviar}>
          <Campo>
            <Etiqueta htmlFor="nombre">Nombre completo</Etiqueta>
            <Entrada id="nombre" value={datos.nombre} onChange={cambiar('nombre')} autoComplete="name" required />
          </Campo>
          <Campo>
            <Etiqueta htmlFor="email">Email</Etiqueta>
            <Entrada id="email" type="email" value={datos.email} onChange={cambiar('email')} autoComplete="email" required />
          </Campo>
          <Campo>
            <Etiqueta htmlFor="telefono">Teléfono (opcional)</Etiqueta>
            <Entrada id="telefono" type="tel" value={datos.telefono} onChange={cambiar('telefono')} autoComplete="tel" />
          </Campo>
          <Campo>
            <Etiqueta htmlFor="password">Contraseña (mínimo 8 caracteres)</Etiqueta>
            <Entrada
              id="password"
              type="password"
              value={datos.password}
              onChange={cambiar('password')}
              autoComplete="new-password"
              minLength={8}
              required
            />
          </Campo>
          <Button type="submit" $completo disabled={enviando}>
            {enviando ? 'Creando cuenta…' : 'Registrarme'}
          </Button>
        </form>
        <PieForm>
          ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
        </PieForm>
      </Card>
    </Envoltura>
  );
}

export default Registro;
